<template>
	<div
		:id="ad.id"
		class="ad instreamAd"
		:class="ad && ad.pos ? 'ad-'+ad.pos : ''"
	></div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

export default {
	data() {
		return {
			clientWidth: document.body.clientWidth,
			ecdQuery: '',
		};
	},
	created() {
		this.store = useStore(this.$pinia);
		this.ecdQuery = this.store?.route?.query?.ecd || '';
	},

	props: {
		ad: {
			type: Object,
			default() {
				return {};
			},
		},
		first: {
			type: Boolean,
		},
		last: {
			type: Boolean,
		},
		bypassRefresh : {
			type: Boolean
		},
		slideNum: {
			type: String,
		},
		partOfTest: {
			type: Boolean,
		},
		contentType: {
			type: String,
			default() {
				return 'article';
			},
		},
		margin: {
			type: Object,
			default() {
				return {
					top: 0,
					bottom: 0,
				};
			},
		},
		chronId: {
			type: String,
		}
	},
	methods: {
		initObserver(adId) {
			const self = this;
			const options = {
				rootMargin: `${self.margin.bottom}px 0px ${self.margin.top}px 0px`,
			};
			const observer = new IntersectionObserver(
				self.observeIntersection,
				options,
			);

			[...document.querySelectorAll(adId)].forEach((el) => {
				observer.observe(el);
			});
		},

		clearAdsOnLoad(artid, adid) {
			let idVal = adid % 9;
			idVal = idVal === 0 ? (9 * ((adid / 9)-1)) : idVal;
			const idToDestroy = `infinite-ad-${artid}-${idVal}`;
			window.webmd.ads.destroy([idToDestroy]);
		},

		observeIntersection(entries) {
			const self = this;
			entries.forEach((entry) => {
				setTimeout(() => {
					self.currentY = window && window.pageYOffset;
					if (entry.isIntersecting && !(window.lastAdLoaded === self.ad.id)) {
						let adsCheck;
						window.lastAdLoaded = self.ad.id;
						const id = entry?.target?.id?.split('-');
						const adid = id && id.length ? id[id.length - 1] : 0;
						const artid = id && id.length ? id[id.length - 2] : 0;
						// load first 3 ads on initial load
						if (!self.previousY) {
							if ((!window.viewportFlag && self.contentType === 'article') || (self.contentType === 'slideshow' && this.clientWidth < 767 && this.ecdQuery.includes('conmktmfb'))) {
								adsCheck = (self.ad.id === 'infinite-ad-1-1' || self.ad.id === 'infinite-ad-1-2' || self.ad.id === 'infinite-ad-1-3');
							} else {
								adsCheck = (self.ad.id === 'infinite-ad-1-1' || self.ad.id === 'responsive_sharethrough_1_1_1');
							}
						}
						if (adsCheck && !window?.webmd?.ads?.ads[self.ad.id]) {
							if (window.googletag && window.googletag.apiReady) {
								// force a new correlation id
								window.googletag.pubads().updateCorrelator();
							}
							//commeting the below code as tug values are getting overwritten from store on last page.
							window.webmd.ads.setPageTarget('tug', window.s_tug);
							self.ad.targets.tug = window.s_tug;
							if (!window.viewportFlag || self.contentType === 'slideshow' || adsCheck) {
							    window.webmd.adsConsumer.defineAd(self.ad);
							}
						} else if (self.currentY >= self.previousY && (!window.viewportFlag || self.contentType === 'slideshow' || adsCheck)) {
							if (self.first && this.clientWidth <= 767) {
								self.destroySlots([2025]);
								self.destroyAndDefineAD('ad-pos-2025-1', 2025);
							}
							self.defineOrRefreshAd(entry.target, self.ad, 'down');
						} else if (self.currentY < self.previousY && (!window.viewportFlag || self.contentType === 'slideshow' || adsCheck)) {
							if (self.last && this.clientWidth <= 767) {
								self.destroySlots([2025]);
								self.destroyAndDefineAD('ad-pos-2025-1', 2025);
							}
							self.defineOrRefreshAd(entry.target, self.ad, 'up');
						}

						if (self.contentType === 'article') {
							if (!window.viewportFlag && adid >= 10) {
								this.clearAdsOnLoad(artid, adid);
							} else {
								self.destroyPrevAd();
							}
						} else if (this.contentType === 'slideshow' && this.clientWidth < 467) {
							self.destroyPrevAd();
						}
					}
					self.previousY = self.currentY;
				}, 0);
			});
		},

		refreshAds(adPosition, adId) {
			if (window.webmd.ads.ads[adPosition]) {
				const adsobj = {};
				adsobj[adId] = true;
				adsobj[adPosition] = true;
				window.webmd.ads.refresh({ id: adsobj });
			}
		},

		defineOrRefreshAd(el, ad, dir) {
			const self = this;
			const adsObj = {};
			const prevAdIdDown = ad.id.replace(/-(\d+)$/, (match, p1) => `-${p1 && p1 > 1 ? p1 - 1 :  1}`);
			const prevAdIdUp = ad.id.replace(/-(\d+)$/, (match, p1) => `-${parseInt(p1, 10) + 1}`);
			if (window.googletag && window.googletag.apiReady) {
				// force a new correlation id
				window.googletag.pubads().updateCorrelator();
			}
			if (window.webmd.ads && window.webmd.ads.ads && !window.webmd.ads.ads[ad.id]) {
				window.webmd.ads.setPageTarget('tug', window.s_tug);
				// eslint-disable-next-line no-param-reassign
				ad.targets.tug = window.s_tug;
				window.webmd.adsConsumer.defineAd(ad);
				adsObj[ad.id] = true;
				if (this.clientWidth <= 767 && window.webmd.ads.ads['ad-pos-2025-1']) {
			        adsObj['ad-pos-2025-1'] = true;
				}

				if (this.isNewTabSpec && window.webmd.ads.ads['ad-pos-101-1']) {
					adsObj['ad-pos-101-1'] = true;
				}
			    
				// added below conditon for vertical desktop slideshow
				if ((this.contentType === 'slideshow' && this.clientWidth > 767) && !this.isNewTabSpec) {
					self.destroyAndDefineAD('ad-pos-121-1', 121);
					const ssId = document.querySelectorAll('.webmd-tool-slideshow').length;
					if(ssId > 1 && this.first) {						
						const banneradId = 'ad-101-'+ssId;
					    self.loadAd(banneradId, 101, [[728, 90], [970, 90], [970, 250]]);
						if (window.webmd.ads.ads[banneradId]) {
                        	adsObj[banneradId] = true;
					    }
					}
					if (window.webmd.ads.ads['ad-pos-121-1']) {
                        adsObj['ad-pos-121-1'] = true;
					}

					if (this.partOfTest && dir === 'up' && !self.last) {
						if (window?.webmd?.ads?.ads && window.webmd.ads.ads[prevAdIdUp]) { 
							window.webmd.ads.destroy([prevAdIdUp]);
						}
					} else if(this.partOfTest && dir === 'down') {
						if (window?.webmd?.ads?.ads && window.webmd.ads.ads[prevAdIdDown]) { 
							window.webmd.ads.destroy([prevAdIdDown]);
						}
					}
				}
				if (this.contentType === 'slideshow' && this.clientWidth > 767) {
					if (!(document.querySelectorAll('.webmd-tool-slideshow').length === 1 && this.first)) {
						if (this.ecdQuery.includes('conmkt')) {
							self.destroyAndDefineAD('ad-pos-101-1', 101);
							if (window.webmd.ads.ads['ad-pos-101-1']) {
                        		adsObj['ad-pos-101-1'] = true;
							}
						}
					}
				}

				if (this.contentType === 'slideshow' && this.clientWidth > 1023) {
					self.destroyAndDefine113();
				}

				if (this.contentType === 'slideshow' && this.clientWidth >767 && this.clientWidth < 1023 && this.ecdQuery.includes('conmkttjg')) {
					self.destroyAndDefine141();
					if (window.webmd.ads.ads['footer-ad-pos-141'] && window.webmd.ads.initialLoadDisabled) {
						adsObj['footer-ad-pos-141'] = true;
					}
				}

				if (this.first && !window.webmd.ads.ads['ad-pos-1901-1']) {
					window.webmd.adsConsumer.defineAd({
						pos: 1901,
						id: 'ad-pos-1901-1',
						targets: self.store.pagedata.ad.targets,
					});
				}
				if (dir === 'down' && this.contentType === 'article' && !(ad.id === 'infinite-ad-1-2' || ad.id === 'infinite-ad-1-3')) {
					this.toggleAdContainerVisibility(false);
				}
				// refreshing the ads once all are defined
				if (window.webmd.ads.initialLoadDisabled) {
				    window.webmd.ads.refresh({ id: adsObj });
				}
			} else if (window.webmd.ads && window.webmd.ads.ads && window.webmd.ads.ads[ad.id]) {
				// adding below conditon for vertical desktop slideshow
				if (this.contentType === 'slideshow' && this.clientWidth > 767) {
						if (window.webmd.ads.ads['ad-pos-121-1']) {
							if (this.partOfTest && dir === 'up' && !self.last) {
								if (window?.webmd?.ads?.ads && window.webmd.ads.ads[prevAdIdUp]) { 
									window.webmd.ads.destroy([prevAdIdUp]);
								}
							} else if(this.partOfTest && dir === 'down') {
								if (window?.webmd?.ads?.ads && window.webmd.ads.ads[prevAdIdDown]) { 
									window.webmd.ads.destroy([prevAdIdDown]);
								}
							}
						}
					this.refreshAds('ad-pos-121-1', ad.id);
					this.refreshAds('ad-pos-113-1', ad.id);

					if (this.clientWidth > 767 && this.clientWidth < 1025) {
						this.refreshAds('ad-pos-101-1', ad.id);
					}
				} else {
					if (!window.viewportFlag || this.contentType === 'slideshow') {
						if (dir === 'down' && this.contentType === 'article' && (ad.id === 'infinite-ad-1-2' || ad.id === 'infinite-ad-1-3')) {
							if (window.firstTimeLoaded) {
							    this.toggleAdContainerVisibility(true);
								if (ad.id === 'infinite-ad-1-3') {
									window.firstTimeLoaded = false;
								}
							}
						} else {
							const bannerAd = this.clientWidth < 767 ? 'ad-pos-2025-1' : 'ad-pos-101-1';
							this.toggleAdContainerVisibility(false);
							adsObj[ad.id] = true;	
							adsObj[bannerAd] = true;
							window.webmd.ads.refresh({ id: adsObj });
						}
					}
				}
			}
			if (dir === 'down') {
				window.webmd.ads.setPageTarget('pg', ad.targets.pg);
			} else if (dir === 'up') {
				window.webmd.ads.setPageTarget('pg', `${ad.targets.pg}u`);
			}
		},

		destroySlots(excludePos) {
			const destroy = [];
			const excluded = excludePos || [];

			// DO not destroy if window variables are not defined or if the page is not infinite
			if (!window.webmd || !window.webmd.ads || !this.isInfinite) {
				return;
			}

			if (this.contentType === 'slideshow') {
				excluded.push(2025, 121, 101, 113);
			}

			Object.keys(window.webmd.ads.ads).forEach((ad) => {
				const thisAd = window.webmd.ads.ads[ad];

				if (!excluded.includes(parseInt(thisAd.pos, 10))) {
					destroy.push(ad);
				}
			});

			window.webmd.ads.destroy(destroy);
		},

		destroyAndDefine113() {
			const rrAdId = 'ad-pos-113-1';
			if (window?.webmd?.ads?.ads && window.webmd.ads.ads[rrAdId]) {
				window.webmd.ads.destroy(['ad-pos-113-1']);
				window.webmd.adsConsumer.defineAd({
					id: 'ad-pos-113-1',
					pos: '113',
					sizes: [[160, 600]],
					targets: this.store.pagedata.ad.targets,
					blockCodes: this.store.pagedata.ad.blockCodes,
				});
				if (window.webmd.ads.ads[rrAdId] && window.webmd.ads.initialLoadDisabled) {
				    window.webmd.ads.refresh({ id: rrAdId });
				}
			}
		},

		loadAd(adId, posValue, adSizes) {
			if (window && window.webmd && window.webmd.adsConsumer && !window.webmd.ads.ads[adId]) {
				window.webmd.adsConsumer.defineAd({
					id: adId,
					class: 'ad-wrapper',
					pos: posValue,
					sizes: adSizes,
				});
			}
		},
		toggleAdContainerVisibility(hideElement) {
			const bannerAd = this.clientWidth < 767 ? 'ad-container-2025' : 'ad-container-101';
			const adContainers = document.getElementsByClassName(bannerAd);
			// Apply visibility change to all matching elements
			for (let i = 0; i < adContainers.length; i++) {
				if (hideElement) {
					// Hide the element
					adContainers[i].style.display = 'none';
				} else {
					// Show the element
					adContainers[i].style.display = ''; // Reset to default display value
				}
			}
		},

		destroyAndDefine141() {
			const footerAdId = 'footer-ad-pos-141';
			if (window.webmd.ads && window.webmd.ads.ads && window.webmd.ads.ads[footerAdId]) {
				window.webmd.ads.destroy(['footer-ad-pos-141']);
				window.webmd.adsConsumer.defineAd({
					id: 'footer-ad-pos-141',
					pos: '141',
					sizes: [[728, 90],[728, 92]],
					targets: this.store.pagedata.ad.targets,
					blockCodes: this.store.pagedata.ad.blockCodes,
				});

			}
		},

		destroyAndDefineAD(adId, posValue) {
			if (window.webmd.ads && window.webmd.ads.ads && window.webmd.ads.ads[adId]) {
				window.webmd.ads.destroy([adId]);
				window.webmd.adsConsumer.defineAd({
					id: adId,
					pos: posValue,
					targets: this.store.pagedata.ad.targets,
					blockCodes: this.store.pagedata.ad.blockCodes,
				});
			}
		},

		// Destroy the first instream ad in the ads object if the ads length is more than 10
		destroyPrevAd() {
			if (window.webmd && window.webmd.ads && window.webmd.ads.ads) {
				let infAdsArray = [];
				Object.keys(window.webmd.ads.ads).forEach((ad) => {
					if (ad.includes('infinite-ad') || ad.includes('browsiAd') || ad.includes('responsive_sharethrough')) {
						infAdsArray.push(ad);
					}
				});
				if (infAdsArray.length > 10) {
					window.webmd.ads.destroy([infAdsArray[0]]);
				}
			}
		}
	},
	mounted() {
		let element;
		if (this.contentType === 'slideshow' && this.clientWidth > 467 && !this.partOfTest) {
			element = `[data-artid="${this.chronId}"] #slide-${this.slideNum} .slide-header`;
		} else {
			element = `#${this.ad.id}`;
		}
		this.isNewTabSpec = window.screen.width > 767 && window.screen.width < 1025 && !(this.ecdQuery.includes('conmkt'));
		this.initObserver(element);
	},
	computed: {
		isInfinite() {
			if (this.$pinia) {
				return this.store.flow.isInfinite;
			}

			return false;
		},
	},

};
</script>

<style lang="scss" scoped>
.ad.instreamAd {
	left: -0.625rem;
	min-height: 18rem;
	width: calc(100% + 1.25rem);
}
</style>

<style lang="scss">
.ad.instreamAd {

	&>div {
		position: sticky;
		top: 3.75rem;
	}
}
</style>
